module.exports = __webpack_public_path__ + "static/media/right-purple.5c6354fb.svg";